module.exports = __webpack_public_path__ + "img/icon-preview.bf98bca9.png";